/**
 * Email Configuration API
 * Feature: System Administration Interface (001-admin-settings)
 */
import { fetcher } from '../utils/fetcher';
import type {
  EmailConfiguration,
  EmailConfigurationUpdate,
  EmailTestRequest,
  EmailTestResponse
} from '../types/email-config';

const API_URL = '/api/v1/email-configuration';

export const getEmailConfiguration = async (): Promise<EmailConfiguration> => {
  return await fetcher(`${API_URL}/read`);
};

export const updateEmailConfiguration = async (
  updates: EmailConfigurationUpdate
): Promise<EmailConfiguration> => {
  return await fetcher(`${API_URL}/update`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(updates),
  });
};

export const testEmailConfiguration = async (
  request: EmailTestRequest
): Promise<EmailTestResponse> => {
  return await fetcher(`${API_URL}/test`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
};
